import React from 'react';

import {
  BrandKit,
  ButtonProps,
  SelectListFilter,
  useTheme,
} from '@sandtech-hub-monorepo/ui-kit';
import { useGeoPicker } from './picker';

// FIT's learners are mostly North American, so these lead its list in this
// order (PEDS-17312); the rest stay alphabetical below them.
const FIT_PINNED = ['US', 'CA', 'GB'];

export const CountryPicker = ({
  selected,
  handleOnSelect,
  triggerVariant,
  triggerClassName,
}: {
  selected?: string;
  handleOnSelect?: (item: { value: string; label: string }) => void;
  triggerVariant?: ButtonProps['variant'];
  triggerClassName?: string;
}) => {
  const { getCountries } = useGeoPicker();
  const pinned = useTheme().brandKit === BrandKit.FIT ? FIT_PINNED : [];
  const rank = (value: string) =>
    pinned.includes(value) ? pinned.indexOf(value) : pinned.length;

  return (
    <SelectListFilter
      // Array.sort is stable, so unpinned countries keep their order.
      items={getCountries().sort((a, b) => rank(a.value) - rank(b.value))}
      defaultValue={selected}
      handleChange={handleOnSelect}
      variant={triggerVariant}
      triggerClassName={triggerClassName}
    />
  );
};
